/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { CBQQuestionType } from "./cbqStudentTypes";

// Per-type answer payloads, matching the save-response contract:
//   mcq:            { mcq: { answer } }
//   multi_response: { multiResponse: { answers } }
//   dropdown:       { dropdown: { blanks } }
//   ordering:       { dragDropOrdering: { placements } }
//   classification: { dragDropClassification: { zones } }
//   numeric:        { numeric: { value } }
// `type` is always sent so flag-only updates still validate.
export type CBQResponseBody = {
  type: CBQQuestionType;
  isFlagged?: boolean;
  mcq?: { answer: string };
  multiResponse?: { answers: string[] };
  dropdown?: { blanks: Record<string, string> };
  dragDropOrdering?: { placements: Record<string, string> };
  dragDropClassification?: { zones: Record<string, string[]> };
  numeric?: { value: number };
};

type SaveCBQResponseResult = {
  error?: ApiError | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
};

// PATCH /cbq/sessions/:cbqSessionId/responses/:cbqScenarioQuestionId
export const SaveCBQResponse = async (
  cbqSessionId: string,
  cbqScenarioQuestionId: string,
  body: CBQResponseBody
): Promise<SaveCBQResponseResult> => {
  try {
    const response = await axios.patch(
      `/cbq/sessions/${cbqSessionId}/responses/${cbqScenarioQuestionId}`,
      body
    );
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
